import { render } from "./tw-avatar.vue?vue&type=template&id=703cbc38"
import script from "./tw-avatar.vue?vue&type=script&lang=js"
export * from "./tw-avatar.vue?vue&type=script&lang=js"
script.render = render

export default script